import * as ents from '@attain-apps/entities'

/**
 * @see {@link ents.core.admin.User}
 * NOTE: 'cognitoId' is intentionally excluded as it is not intended for
 * frontend use.
 */
export type User = Pick<ents.core.admin.User, 'id' | 'isPlatformAdmin' | 'name'>

export namespace User {
  const AGENT_ACCESS_FLAGS = ents.core.admin.Access.Flag.WithLabel.get().filter(
    flag =>
      flag.value === ents.core.admin.Access.Flag.CanUse ||
      flag.value === ents.core.admin.Access.Flag.CanConfigureFunctionality,
  )

  export interface Filters {
    context?:
      | ents.core.admin.Context.ForTenant
      | ents.core.admin.Context.ForZone
      | ents.core.admin.Context.ForApp
  }

  /**
   * Returns agent access flags available for the selected users.
   */
  export function getAccessFlags(
    selectedUsers: readonly User[],
  ): readonly ents.core.admin.Access.Flag.WithLabel[] {
    return selectedUsers.some(user => user.isPlatformAdmin)
      ? AGENT_ACCESS_FLAGS.filter(
          flag => flag.value === ents.core.admin.Access.Flag.CanUse,
        )
      : AGENT_ACCESS_FLAGS
  }

  /**
   * Limits agent access to the available flags for selected users.
   */
  export function limitAccessToFlags(
    access: ents.core.admin.Access,
    flags: readonly ents.core.admin.Access.Flag.WithLabel[],
  ): ents.core.admin.Access {
    return ents.core.admin.Access.intersection(
      access,
      ents.core.admin.Access.union(...flags.map(flag => flag.value)),
    )
  }
}
